import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { AuthDataService } from '../services/auth/auth-data.service';
import { RawHttpParamsEncoder } from './raw-http-params.encoder';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  constructor(
    private injector:Injector
  ) {
    /**/
  }

  public intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>> {
    const params:URLSearchParams = new URLSearchParams(req.clone().params.toString());

    // all rest calls apart from translations, GA1 create session call, or ga3 forms
    if ((req.url.includes('rest') && !req.url.includes('i18n')) || req.url === AuthDataService.CREATE_SESSION_URL || req.url.includes('/ga3/')) {
      const authService:AuthService = this.injector.get(AuthService);

      if (authService.getToken()) {
        params.append('token', authService.getToken());
      }

      if (authService.alternateUserId) {
        params.append('alternateUserId', authService.alternateUserId.toString());
      }
    }
    // sort query params by alphabetically
    params.sort();

    // Since the encoding is handled on the Angular side via HttpDataService.doHTTP, here we only need to return the parameters as is.
    // This is to avoid double encoding, when setting new parameter in this interceptor using HttpParams
    const httpParams:HttpParams = new HttpParams({ fromString: params.toString(), encoder: new RawHttpParamsEncoder() });
    return next.handle(req.clone({ params: httpParams }));
  }
}
